<div class="header-search-bar full-container">
  <div class="container-wrapper">
    <div class="d-flex justify-content-between track-ticket-wrapper">
      <a href="./">
        <img _ngcontent-rfy-c24="" src="https://images.5paisa.com/Campaign/5paisa-logo.svg" alt="5paisa Logo" title="5paisa Logo">
      </a>

      <span *ngIf="isLoggedIn == 'Y'" class="track-ticket" onclick="openTicketsTab()">Track Ticket</span>
    </div>
  <!-- <img src="https://images.5paisa.com/Campaign/5paisa-logo.svg" /> -->
  <h1 class="fw-500 text">How can we help you?</h1>
  <div class="form-tab">
    <div class="search-field d-flex position-relative w-100">
      <span class="icon-search"></span>
      <form [formGroup]="searchForm" novalidate>
        <input autocomplete="off" type="text" pattern="\S+.*" name="input" id="input" class="text-field"
          placeholder="Eg: how do i activate F&O ?" formControlName="searchText" (keyup)="searchByString()" />
        <ul class="results" *ngIf="showResults">
          <li *ngFor="let item of searchListArray">
            <a *ngIf="item.title != ''" (click)="goTosubCategoryAnswers(item.id, item.category.id, item.permalink)">{{item.title}}</a>
            <a *ngIf="item == 'No results found'">{{item}}</a>
          </li>
        </ul>
      </form>
    </div>
  </div>
</div>
</div>